import angular from 'angular'
import data from './data';
import polyfill from './polyfill';


export default angular.module('webspinner-ajs', [data, polyfill]).name;